import styled from "styled-components";

export const DriverContainer = styled.div`
  display: grid;
  gap: 2px;
  margin-bottom: 5px;
`;

export const VehicleContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-bottom: 10px;
`;

export const DescriptionName = styled.span`
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DescriptionTitle = styled.span`
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
`;

export const DriverImage = styled.div`
  margin-bottom: 8px;
  display: grid;
  align-items: center;
  gap: 3px;
  margin-top: 8px;
`;

export const Title = styled.div`
  font-size: 16px;
`;

export const CheckContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100%;
  align-items: center;
  height: 90%;
  gap: 10px;
  .spin {
    margin-bottom: 20px;
  }
`;

export const DriverAndVehicleCheckContainer = styled.div`
  margin-top: 20px;
  height: auto;

  .btn-check {
    height: ${(props) => props.theme["@height-button-lg"]};
    width: auto;
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: 1px solid ${(props) => props.theme.colors.text} !important;
    border-radius: ${(props) => props.theme["@border-radius-base"]};
    height: 48px !important;
    margin-top: 10px;
    :hover,
    :focus {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: none !important;
      color: ${(props) => props.theme["@default-color"]};
    }
  }
  .ant-btn[disabled],
  .ant-btn[disabled]:active,
  .ant-btn[disabled]:focus,
  .ant-btn[disabled]:hover {
    background-color: ${(props) => props.theme["@muted-background"]} !important;
    border: 1.6px solid ${(props) => props.theme["@muted-background"]} !important;
    color: ${(props) => props.theme["@disabled-button"]} !important;
  }
`;

export const TitleDriverCheck = styled.div`
  font-size: ${(props) => props.theme["@medium-font-size"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
`;

export const DescriptionNameDriverCheck = styled.span`
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  font-size: ${(props) => props.theme["@medium-font-size"]};
  align-items: center;
  text-align: center;
`;

export const DriverCheckContainer = styled.div`
  .status {
    display: flex;
    padding: 4px 8px;
    width: 122px;
    text-align: center;
    justify-content: center;
    gap: 4px;
    border-radius: 300px;
    border-color: ${(props) => (props.released === 1 ? (props) => props.theme["@color-positive-100"] : (props) => props.theme["@color-danger-100"])};
    background-color: ${(props) => (props.released === 1 ? (props) => props.theme["@color-positive-100"] : (props) => props.theme["@color-danger-100"])};
    font-size: 14px;
    font-weight: 600;
    align-content: center;
    span {
      color: ${(props) => (props.released === 1 ? props.theme["@color-positive-600"] : props.theme["@color-danger-600"])};
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 100%;
    }
  }
`;
